export default "__VITE_ASSET__4407d8f1__"